import React, { Component } from 'react'

class AccountSetup extends Component {

  continue = e => {
    e.preventDefault();
    this.props.nextStep();

  }


  render() {
    const { values, inputChange } = this.props;
    return (
      <div className="form-container">
        <h1>Profile Edit</h1>

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="name" className="form-control" name="name" onChange={inputChange('name')} value={values.name} />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" className="form-control" name="email" onChange={inputChange('email')} value={values.email} />

        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input type="tel" className="form-control" name="phone" onChange={inputChange('phone')} value={values.phone} />

        </div>

        {/* <div className="form-group">
          <label htmlFor="facebook">The Facebook</label>
          <input type="text" className="form-control" name="facebook" onChange={inputChange('facebook')} value={values.facebook} />

        </div>

        <div className="form-group">
          <label htmlFor="youtube">YouTube</label>
          <input type="text" className="form-control" name="youtube" onChange={inputChange('youtube')} value={values.youtube} />

        </div>

        <div className="form-group">
          <label htmlFor="twitter">Twitter</label>
          <input type="text" className="form-control" name="twitter" onChange={inputChange('twitter')} value={values.twitter} />

        </div>

        <div className="form-group">
          <label htmlFor="linkedin">Linkedin</label>
          <input type="text" className="form-control" name="linkedin" onChange={inputChange('linkedin')} value={values.linkedin} />

        </div>

        <div className="form-group">
          <label htmlFor="instagram">Instagram</label>
          <input type="text" className="form-control" name="instagram" onChange={inputChange('instagram')} value={values.instagram} />

        </div> */}


        <br />

        <div className="text-right">
          <button className="btn btn-primary" onClick={this.continue}>Continue</button>

        </div>
      </div>
    )
  }

}
export default AccountSetup